<template>
  <div class="liquor-category">
    <div class="split-logo">
      <img src="/liquor/图形.png" alt />
    </div>
    <div class="header">
      酒分类
      <img src="/liquor/酒的分类体系.png" />
    </div>
    <div class="top">
      <div
        v-for="(item, index) in list"
        :key="index"
        class="item"
        @mouseover="onChange(index)"
        @click="goto()"
      >
        <div class="name">{{item.name}}</div>
        <img class="image" :src="item.image" />
        <img class="hover" src="/liquor/菱形.png" v-show="currIndex === index" />
      </div>
    </div>
    <div class="bottom" @click="goto()">
      <div class="left">
        <div class="title">{{list[currIndex].name}}</div>
        <div class="content">{{list[currIndex].description}}</div>
        <img :src="list[currIndex].background" />
      </div>
      <div class="right">
        <img :src="list[currIndex].background" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LiquorCategory",
  methods: {
    onChange(index) {
      this.currIndex = index;
    },
    goto() {
      this.$router.push({
        path: "/liquor/browser",
        query: {
          3: this.list[this.currIndex].value
        }
      });
    }
  },
  data() {
    return {
      currIndex: 1,
      list: [
        {
          label: 3,
          value: "123203",
          name: "白酒",
          image: "/liquor/白酒.png",
          background: "/liquor/白酒背景.jpg",
          description:
            "中国白酒是蒸馏酒的一种，以曲类、酒母为糖化发酵剂，利用淀粉质（糖质）原料，经蒸煮、糖化、发酵、蒸馏、陈酿和勾兑而酿制而成的各类酒。酒曲酿酒使白酒形成了复杂的以酯类为主的浓郁香味。"
        },
        {
          label: 3,
          value: "123207,123208",
          name: "葡萄酒",
          image: "/liquor/葡萄酒.png",
          background: "/liquor/葡萄酒背景.jpg",
          description:
            "葡萄酒属于酿造酒，是用破碎或未破碎的新鲜葡萄果实或葡萄汁经完全或部分酒精发酵所获得的低酒精饮料，在20℃下测得酒精含量不得低于8.5% vol。"
        },
        {
          label: 3,
          value: "123201,123202",
          name: "啤酒",
          image: "/liquor/啤酒.png",
          background: "/liquor/啤酒酒背景.jpg",
          description:
            "啤酒是以大麦和小麦等谷物为原料，经发芽（有些是部分大麦芽）、糖化，然后加入少许啤酒花（蛇麻草），再通过发酵后生产而成的低酒精饮料，含有丰富的多种氨基酸和维生素，还有无机盐和多种酶等营养价值。"
        },
        {
          label: 3,
          value: "123206",
          name: "洋酒",
          image: "/liquor/洋酒.png",
          background: "/liquor/洋酒背景.jpg",
          description:
            "洋酒属于蒸馏酒，以水果、谷物或植物等为原料，经糖化发酵后蒸馏而成，酒精度大多在32%~65% vol.之间，耐久存。苏格兰威士忌、法国白兰地丶俄罗斯伏特加丶加勒比海朗姆酒丶英国杜松子酒丶墨西哥龙舌兰酒为世界六大西式烈酒。"
        },
        {
          label: 3,
          value: "123204",
          name: "黄酒/滋补酒",
          image: "/liquor/滋补酒.png",
          background: "/liquor/黄酒背景.jpg",
          description:
            "黄酒源于中国，与啤酒、葡萄酒并称世界三大古酒，以糯米、北方以黍米、粟为原料，一般酒精含量为14% vol.~20% vol，属于低度酿造酒。"
        },
        {
          label: 3,
          value: "123205",
          name: "预调酒/其他酒",
          image: "/liquor/其他酒.png",
          background: "/liquor/预调酒背景.jpg",
          description:
            "预调酒/其他酒是以酿造酒或蒸馏酒为基酒，加入酒精或非酒精物质生产而成。此类酒的颜色和口味丰富，酒精含量在3%~40% vol. 之间，鸡尾酒是人们最为熟悉的预调酒之一。"
        },
        {
          label: 3,
          value: "123209",
          name: "酒具配套",
          image: "/liquor/酒具配套.png",
          background: "/liquor/酒具背景.jpg",
          description:
            "酒具，是酒文化最原始的载体。酒具包括盛酒的容器和饮酒的饮具，甚至包括早期制酒的工具。金樽美酒，玉壶流转，酒具的优劣，可以体现饮酒人不同的身份；酒具的演变，可以观照时代的变迁。"
        }
      ]
    };
  }
};
</script>

<style lang="scss">
.liquor-category {
  width: 1100px;
  margin: 0 auto;

  .split-logo {
    width: 90px;
    margin: 50px auto;
    margin-top: -85px;
    img {
      width: 90px;
    }
  }

  .header {
    width: 323px;
    margin: 0 auto;
    height: 36px;
    font-size: 32px;
    font-family: "FZQKBYSJW";
    font-weight: normal;
    color: rgba(59, 41, 9, 1);
    line-height: 36px;
    text-align: center;

    position: relative;

    img {
      position: absolute;
      top: 0;
      left: 0;
      width: 323px;
      height: 36px;
    }
  }

  .top {
    margin-top: 100px;
    display: flex;

    justify-content: space-between;

    .item {
      width: 148px;
      height: 208px;
      writing-mode: vertical-lr;
      cursor: pointer;

      .name {
        width: 18px;
        margin-left: 13px;
        margin-top: -20px;
        display: inline-block;
        vertical-align: bottom;

        font-size: 18px;
        font-family: "FZQKBYSJW";
        font-weight: normal;
        color: rgba(59, 41, 9, 1);
        line-height: 20px;
      }

      .image {
        width: 110px;
        margin-left: -10px;
        height: 200px;
        display: inline-block;
      }

      position: relative;
      .hover {
        width: 135px;
        position: absolute;
        top: -65px;
        left: 0;
        z-index: -1;
      }
    }

    .item:hover {
      .image {
        margin-left: -20px;
        margin-top: -50px;
        width: 132px;
        height: 264px;
      }
    }
  }

  .bottom {
    cursor: pointer;
    .left {
      display: inline-block;
      width: 550px;
      height: 312px;
      overflow: hidden;

      .title {
        margin: 45px 0 0 50px;
        height: 36px;
        font-size: 32px;
        font-family: "FZQKBYSJW";
        font-weight: normal;
        color: rgba(255, 255, 255, 1);
        line-height: 36px;
      }

      .content {
        margin: 30px 50px 0 50px;
        height: 90px;
        font-size: 16px;
        font-weight: 400;
        color: rgba(191, 191, 191, 1);
        line-height: 30px;
      }

      position: relative;
      background: rgba(0, 0, 0, 0.7);
      //   opacity: 0.99;
      img {
        width: 550px;
        position: absolute;
        z-index: -1;
        top: 0;
        filter: blur(10px);
      }
    }

    .right {
      display: inline-block;
      width: 550px;
      height: 312px;
      overflow: hidden;

      img {
        width: 550px;
      }
    }
  }
}
</style>